/**
* 开户判断
* 说明：整合了基础账户、卡牛信用卡还款账户、非标存管账户
*/
import '@common/polyfill/src/Object.assign'
import { accountAcc } from './account_acc'
import { accountCustody } from './account_custody'
import { accountTypes } from '../dict'

export const openAccount = (options) => {
  const _options = Object.assign({
    accountType: accountTypes.custody,
    origin: '',
    forwardUrl: window.location.href,
    currentView: false, // 是否在当前窗口打开开户url
    isShowAccountCustodyDialog: true, // 存管账户是否先弹窗提示
    success: () => { }, // 成功回调
    error: () => { }, // 失败回调
    cancel: () => { } // 取消登录回调
  }, options)
  switch (_options.accountType) {
    case accountTypes.acc:
      accountAcc(_options)
      break
    case accountTypes.custody:
      accountCustody(_options)
      break
    default:
      console.error('Account Error: Wrong accountType config!')
  }
}

export default {
  openAccount
}



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/account/account.js